export const getVersion = () => {
  if (process.env.NODE_ENV !== 'production') {
    return '1';
  }

  if (process.browser) {
    const versionFromMetaTag = document
      .querySelector("meta[name='version']")
      ?.getAttribute('content');
    if (versionFromMetaTag) {
      return versionFromMetaTag;
    }
    throw new Error(`Received Version from Meta Tags as ${versionFromMetaTag}`);
  }

  const version = process.browser
    ? `devBuild_${process.env.VERSION}`
    : process.env.VERSION;

  return version ?? 'no_version';
};

export const getVersionName = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'dev';
  }

  if (process.browser) {
    const versionFromMetaTag = document
      .querySelector("meta[name='version_name']")
      ?.getAttribute('content');
    if (versionFromMetaTag) {
      return versionFromMetaTag;
    }
    throw new Error(`Received Version from Meta Tags as ${versionFromMetaTag}`);
  }

  const version = process.browser
    ? `devBuild_${process.env.VERSION_NAME}`
    : process.env.VERSION_NAME;
  return version ?? 'no_version_name';
};
